import { Container, Stack, Typography, Grid } from "@mui/material";
import React from "react";
import ServiceCard from "../../components/cards/ServiceCard";
import { useSelector } from "react-redux";
import ServiceCardSkeleton from "../../components/skeletons/ServiceCardSkeleton";
import { t } from "i18next";

const Services = () => {
  const { isLoading, data } = useSelector((state) => state.serviceReducer);

  return (
    <Container sx={{ maxWidth: "1100px !important", my: 6 }}>
      <Stack textAlign={"center"} mb={5}>
        <Typography
          variant="heading_pr"
          component={"h1"}
          textTransform={"capitalize"}
        >
          {t("ourServices")}
        </Typography>
        <Typography variant="heading_sec" component={"p"}>
          {t("allServiceSubTitle")}.
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        {isLoading
          ? Array.from({ length: 6 }).map((_, index) => (
              <Grid key={index} item xs={12} sm={6} md={4}>
                <ServiceCardSkeleton />
              </Grid>
            ))
          : data?.map((val, index) => (
              <Grid key={index} item xs={12} sm={6} md={4}>
                <ServiceCard cardData={val} />
              </Grid>
            ))}
      </Grid>
    </Container>
  );
};

export default Services;
